import Icon from '../Icon.vue'

Icon.register({
  'accessible': {
    width: 10,
    height: 10,
    paths: [
      {
        d: 'M9.69 7.533l.277.56a.312.312 0 01-.14.418l-1.28.643a.625.625 0 01-.843-.294L6.478 6.25H3.75a.625.625 0 01-.619-.537l-.37-2.588H6.563c.173 0 .313.14.313.313v.625c0 .172-.14.312-.313.312h-2.36l.09.625h2.583c.242 0 .463.14.566.36l1.123 2.39.707-.358a.313.313 0 01.418.14zM3.75 2.5a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zm2.331 4.375h-.478A2.19 2.19 0 013.438 8.75 2.19 2.19 0 011.25 6.562c0-.81.443-1.52 1.1-1.897l-.185-1.296A3.443 3.443 0 000 6.562 3.441 3.441 0 003.438 10a3.442 3.442 0 003.146-2.055l-.503-1.07z'
      }
    ]
  }
})
